<template lang="html">
  <div class="pager d-flex align-center justify-space-between px-2 pt-0 pb-12 pa-sm-0">
    <div class="d-flex">
      <button class="d-flex align-center"
        :class="selected === 1 ? 'disabled-nav' : ''"
        :disabled="selected === 1"
        @click="goHardLeft()">
          <img :src="LeftCollapsedIcon" />
      </button>
      <button class="inner-left-pager d-flex align-center ml-1"
        :class="selected === 1 ? 'disabled-nav' : ''"
        :disabled="selected === 1"
        @click="goLeft()">
          <img :src="LeftIcon" />
        </button>
    </div>
    <div class="pages">
      <ul>
        <li
          v-for="question in displayQ"
          :key="question"
        >
        <button
          class="pager-button d-flex flex-column justify-center align-center px-2 py-4 mx-1"
          :class="selected > question ? 'passed' : selected === question ? 'active' : ''"
          @click="selectQuestion(question)">
            <p class="mb-0">
              {{ question }}
            </p>
        </button>
        </li>
      </ul>
    </div>
    <div class="d-flex">
      <button class="inner-right-pager d-flex align-center mr-1"
        :class="selected === questions.length ? 'disabled-nav' : ''"
        :disabled="selected === questions.length"
        @click="goRight()">
          <img :src="RightIcon" />
      </button>
      <button class="d-flex align-center    "
        :class="selected === questions.length ? 'disabled-nav' : ''"
        :disabled="selected === questions.length"
        @click="goHardRight()">
          <img :src="RightCollapsedIcon" />
      </button>
    </div>
  </div>
</template>

<script lang="js">
import LeftCollapsedIcon from '../../../public/img/icons/collapse-left.svg'
import RightCollapsedIcon from '../../../public/img/icons/collapse-right.svg'
import LeftIcon from '../../../public/img/icons/left.svg'
import RightIcon from '../../../public/img/icons/right.svg'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Navigation',
  props: ['section', 'question', 'current'],
  data: () => ({
    LeftIcon,
    RightIcon,
    LeftCollapsedIcon,
    RightCollapsedIcon,
    displayQ: [],
    start: 5,
    threshold: null
  }),
  methods: {
    ...mapActions({
      setSelected: 'question/setSelected',
      setShowSolution: 'question/setShowSolution'
    }),
    updateCard () {
      var selectedValue = document.querySelector('.active .number p').innerText
      this.$emit('done', parseInt(selectedValue))
    },
    selectQuestion (id) {
      this.setSelected(id)
      this.setShowSolution(false)
      if (id === this.displayQ[this.threshold - 1]) {
        this.slideRight()
      } else if (id === this.displayQ[0]) {
        this.slideLeft()
      }
    },
    goLeft () {
      this.setShowSolution(false)
      this.slideLeft()
      this.setSelected(this.selected - 1)
    },
    slideLeft () {
      const end = this.displayQ[0]
      const start = end - this.threshold
      if (this.selected === this.displayQ[0]) {
        if (start > 0) {
          this.displayQ = this.questions.slice(start, end)
        } else {
          this.slideHardLeft()
        }
      }
    },
    goHardLeft () {
      this.setShowSolution(false)
      this.setSelected(1)
      this.slideHardLeft()
    },
    slideHardLeft () {
      this.displayQ = this.questions.slice(0, this.threshold)
    },
    goRight () {
      this.setShowSolution(false)
      this.setSelected(this.selected + 1)
      this.slideRight()
    },
    slideRight () {
      const start = this.displayQ[this.threshold - 1] - 1
      const end = start + this.threshold
      if (this.selected === this.displayQ[this.threshold - 1]) {
        if (end < this.questions.length) {
          this.displayQ = this.questions.slice(start, end)
        } else {
          this.slideHardRight()
        }
      }
    },
    goHardRight () {
      this.setShowSolution(false)
      this.setSelected(this.questions.length)
      this.slideHardRight()
    },
    slideHardRight () {
      this.displayQ = this.questions.slice(-this.threshold)
    },
    computeThreshold () {
      let screenWidth = window.innerWidth

      switch (true) {
        case screenWidth <= 600 :
          this.threshold = 4
          break
        case (screenWidth > 600 && screenWidth < 1440) :
          this.threshold = 6
          break
        default:
          this.threshold = 10
          break
      }
    },
    setupNav () {
      if (this.selected < this.threshold) {
        this.slideHardLeft()
      } else {
        const start = this.selected - 1
        const end = start + this.threshold
        if ((this.questions.length - start) < this.threshold) {
          this.slideHardRight()
        } else {
          this.displayQ = this.questions.slice(start, end)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      selected: 'question/getSelected',
      nav: 'question/getNav'
    }),
    questions () {
      const array = []
      let i
      const COUNT = this.question
      for (i = 1; i <= COUNT; i++) {
        array.push(i)
      }
      return array
    }
  },
  beforeDestory () {
    if (typeof window === 'undefined') return
    window.removeEventListener('resize', this.computeThreshold, { passive: true })
  },
  mounted () {
    this.computeThreshold()
    window.addEventListener('resize', this.computeThreshold, { passive: true })
    this.setupNav()
  },
  watch: {
    threshold () {
      this.setupNav()
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/variables.scss";
#Assessment {
  .pages {
    display: flex;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    float: left
  }
  .pager {
    .pager-button {
      width: 34px;
      border-radius: 8px;
      border: 1px solid #DAE0E0 !important;
      p {
        color: #082663;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
      }
    }
    .active {
      border: 1px solid #5465FB !important;
      background: #DEDEFF !important;
    }
    .passed {
      background: #EBF0F0 !important;
    }
  }
  .disabled-nav {
    opacity: 0.6;
  }
}
</style>
